export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6204.0bbb563e.jpg";